import { render, staticRenderFns } from "./ManuscriptEditorPage.vue?vue&type=template&id=71371d84&scoped=true&"
import script from "./ManuscriptEditorPage.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptEditorPage.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptEditorPage.vue?vue&type=style&index=0&id=71371d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71371d84",
  null
  
)

export default component.exports